define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var user = require('user');
    var storage = require('util/storage.util');
    var DepositMethodModel = require('portlets/cashier/deposit/deposit.method.model');
    var parent = {
        getRequestData: DepositMethodModel.prototype.getRequestData,
    };

    module.exports = DepositMethodModel.extend({

        deposit: function(data) {
            window.Playtech.API.payments.getPaymentStatistics().then(function(response) {
                storage.session.setItem('deposit_action', {
                    amount: data.amount,
                    count: response.deposits.totalDepositCount,
                    currency: user.get('currencyCode'),
                    playerCode: user.get('playerCode')
                });
            });

            return DepositMethodModel.prototype.deposit.apply(this, arguments);
        },

        getRequestData: function(data) {
            var isPaymentButton = this.get('reDirectType') === 'paymentbuttondt';
            var requestData = parent.getRequestData.call(this, data);

            if (isPaymentButton && data.subMethodsCodes) {
                requestData.subMethodsCodes = data.subMethodsCodes;
            }

            requestData.specificParams = _.omit(
                requestData.specificParams,
                'subMethodsCodes'
            );
            delete data.subMethodsCodes;

            return requestData;
        },
    });
});
